import { render, staticRenderFns } from "./ReportBalanceVariableByRibbon.vue?vue&type=template&id=78627fe7"
import script from "./ReportBalanceVariableByRibbon.vue?vue&type=script&lang=js"
export * from "./ReportBalanceVariableByRibbon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports